import { Avatar } from "@mui/material";
import React from "react";

export default function SmallClientChipV2Mobile(props) {
  return (
    <div className="small-client-chip-container-v2">
      <Avatar
        style={{
          width: "30px",
          height: "30px",
        }}
        src={props.clientPic}
      />
      <div
        className="small-client-chip-name"
        style={{ fontSize: "16px", fontWeight: "600" }}
      >
        {props.firstName} {props.lastName}
      </div>
    </div>
  );
}
